<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Why are you deactivating this
                        employee?</label>
                    <select class="custom-select" v-model="form.deactivating_reason"
                            @change="handleSelectChange">
                        <option value="selectOne" disabled>Select One</option>
                        <option
                            v-for="option in deactivatingOptions"
                            :value="option"
                        >
                            {{ option }}
                        </option>
                        <option value="null">Other</option>
                    </select>
                </div>
                <div class="form-group form-group-1" v-if="form.deactivating_reason === null">
                    <input type="text" class="form-control" v-model="form.deactivating_reason_other">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Last Date of Work</label>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-1 mb-0">
                                <input type="date"
                                       class="form-control"
                                       v-model="form.last_date_work">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Notes</label>
                    <textarea v-model="form.note" type="text" class="form-control height-2"></textarea>
                </div>
            </div>
        </div>
        <div class="row justify-content-between">
            <div class="col-lg-5" v-if="statusInfo.interview">
                <p> Exit Interview emailed on
                    {{ calculateDate(statusInfo.interview.emailed_date) }} by {{ statusInfo.interview.emailed_by.name }} {{statusInfo.interview.emailed_by.last_name}}
                </p>
            </div>
            <button
                v-else
                class="btn btn--outline-primary btn--middle col-md-12 mb-4"
                @click="sendExitInterview"
            >Send Exit Interview</button>
            <div class="col-lg-5" v-if="statusInfo.interview?.completed_date">
                <p>
                    Exit Interview completed on {{calculateDate(statusInfo.interview.completed_date)}}
                   <a
                       class="color--secondary"
                       target="_blank"
                       :href="`/master-admin/applicants/exit-interview/${statusInfo.interview.id}/show`"
                   >
                       <i class="fas fa-eye"></i>
                   </a>
                </p>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group form-group-1">
                <div class="btns-wrap" style="justify-content: flex-end;">
                    <button class="btn btn--secondary w-100 w-sm-auto" @click="updateStatus" >Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DeactivationServices from "../services/DeactivationServices";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'DeactivationStatus',
    mixins: [ModalHandler, DateConverter],
    props: {
        statusInfo: {
            type: Object
        }
    },
    data() {
        return {
            showInterviewDetails: false,
            exitInterviewDetails: null,
            deactivatingOptions: [
                'This person resigned',
                'This person was terminated for cause',
                'This person is inactive',
                'This person disappeared',
                'No openings',
            ],
            form: {
                note: this.statusInfo.note,
                deactivating_reason: this.statusInfo.reason,
                deactivating_reason_other: this.statusInfo.reason_other,
                last_date_work: this.statusInfo.action_date,
            }
        }
    },
    methods: {
        handleSelectChange() {
            if (this.form.deactivating_reason === "null") {
                this.form.deactivating_reason = null;
            }
        },
        async updateStatus() {
            this.$showLoadingMessage()
            try {
                await DeactivationServices.updateStatus(this.statusInfo.id, this.form)
                this.$showSuccessMessage('Your information has been saved')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your information was not saved. Please try again')
            }
        },
        async sendExitInterview() {
            this.$showLoadingMessage('Please wait, interview is being sent')
            try {
                const { data: response } = await DeactivationServices.sendInterview(this.statusInfo.applicant_id, this.statusInfo.id)
                this.$showSuccessMessage('Exit Interview has been sent');
                setTimeout(()=> {
                    this.reloadPage()
                }, 1000)

            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Exit Interview was not sent. Please try again')
            }
        }
    }

}

</script>

<style scoped>

</style>
